<template>
    <el-dialog
        :visible="showFilter"
        width="520px"
        custom-class="login-tip-dialog"
        :before-close="handleClose"
        :show-close="false"
        :close-on-click-modal="!showResetTip"
        :modal-append-to-body="false"
    >
        <div class="login-tip" :style="'height:' + (showResetTip ? '225px' : '180px')">
            <template v-if="!showResetTip">
                <div class="login-tip-title">
                    <i class="msn-fa login-warning-icon"></i>
                    <span> {{ $t("msn.login.tip") }}</span>
                </div>
                <!--bca-disable-->
                <div
                    class="password-compromised"
                    v-html="$t('msn.login.passwordCompromised')"
                ></div>
                <!--bca-enable-->
                <div class="reset-password" @click="handleToFirget">
                    <span>
                        {{ $t("msn.login.resetPassword") }}
                    </span>
                </div>
            </template>
            <template v-else>
                <!--bca-disable-->
                <div class="password-compromised" v-html="$t('msn.login.emailTip')"></div>
                <!--bca-enable-->
                <div
                    class="reset-password" style="padding: 0 48px"
                    @click="handleClose"
                >
                    <span>{{ $t("msn.login.ok") }}</span>
                </div>
            </template>
        </div>
    </el-dialog>
</template>

<script>
import PATH from '@/constants/path';
export default {
    name: 'LoginTip',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        actions: {
            type: String,
            default: 'reset'
        }
    },
    data() {
        return {};
    },
    computed: {
        showFilter: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            }
        },
        showResetTip() {
            return this.actions === 'authCode';
        }
    },
    components: {},
    methods: {
        handleClose() {
            this.showFilter = false;
        },
        handleToFirget() {
            this.$router.push({ path: PATH['forgetPassword'] });
        }
    },
    watch: {},
    mounted() {}
};
</script>

<style scoped lang="scss">
.login-tip {
  // height: 225px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 14px;
  color: #666;
  border-radius: 6px;
  .login-tip-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    color: rgba(0, 0, 0, 1);
    font-weight: 600;
    font-size: 18px;
  }
  .password-compromised {
    text-align: center;
    font-size: 14px;
    color: rgba(0, 0, 0, 1);
  }
  .reset-password {
    background: rgba(0, 103, 255, 1);
    color: #fff;
    font-size: 14px;
    text-align: center;
    border-radius: 20px;
    line-height: 34px;
    margin-top: 32px;
    cursor: pointer;
    height: 34px;
    padding: 0 32px;
    &:hover {
      background: rgba(41, 134, 255, 1);
    }
    &:active {
      background: rgba(0, 79, 217, 1);
    }
  }
  .login-warning-icon {
    margin-right: 5px;
  }
}
</style>
<style lang="scss">
.login-tip-dialog {
  .el-dialog__header {
    display: none !important;
  }
  .el-dialog__body {
    padding: 0 !important;
  }
}

.el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  /*height:600px;*/
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}
.el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(196, 196, 196, 0.7);
    border-radius: 4px !important;
  }
}
</style>